// VERSION : 0.0.1
// AUTHOR : VIGNESH
// LAST EDIT : VIGNESH
// MODIFIED DATE: 07-12-2025
// LAST CHANGED : ADDED COMMENT LINES
import { makeApiCall, makeFormApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/*************** Get Month Wise Interest Summary Report Start ******************/
export const getMonthWiseInterestReport = (fetchData: any) => {
	const data = {
		MonthWiseInterestSummaryReportDataToken: fetchData,
	};
	const url = `${API_URL}getMonthWiseInterestSummaryReport`;
	return makeApiCall(url, data);
};
/*************** Get Month Wise Interest Summary Report End ******************/

/*************** Get Month Wise Interest Summary Report Excel Start ******************/
export const monthWiseInterestSummaryReportExcelget = (branchData: string) => {
	const params = new URLSearchParams();
	params.append('GetMonthWiseInterestSummaryReportExcelDataToken', branchData);
	const url = `${API_URL}Excel/MonthWiseInterestSummaryReport.php`;
	return makeFormApiCall(url, params);
};
/*************** Get Month Wise Interest Summary Report Excel End ******************/
